import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { Respuesta } from '../_models/shared/_index';
import {
	ValidadorCarga,
	FormatoArchivo,
	ColumnaFormatoArchivo,
} from '../_models/abm-formato-archivo/_index';
import { ErrorService } from './error.service';
import { TipoCargaDatosEnum } from 'app/_enums/tipo-carga-datos';

@Injectable()
export class AbmFormatoArchivoService {
	private getFormatosArchivosUrl =
		environment.rest + '/FormatosArchivos/GetFormatosArchivos';
	private getValidadoresUrl =
		environment.rest + '/FormatosArchivos/GetValidadoresFormatoArchivo';
	private addFormatoArchivoUrl =
		environment.rest + '/FormatosArchivos/AddFormatoArchivo';
	private deleteFormatosArchivosUrl =
		environment.rest + '/FormatosArchivos/DeleteFormatoArchivo';
	private updateFormatoArchivoUrl =
		environment.rest + '/FormatosArchivos/UpdateFormatoArchivo';
	private getColumnasFormatoArchivoUrl =
		environment.rest + '/FormatosArchivos/GetColumnasFormatoArchivo';
	private getColumnasSistemaUrl =
		environment.rest + '/FormatosArchivos/GetColumnasSistema';
	private uploadFileUrl = environment.rest + '/FormatosArchivos/UploadFile';

	private getTiposDatosUrl =
		environment.rest + '/FormatosArchivos/GetTiposDatos';
	private getTiposDatosByIdClienteUrl =
		environment.rest + '/FormatosArchivos/GetTiposDatosByIdCliente';
	private deleteOrDisableFormatoArchivoUrl =
		environment.rest + '/FormatosArchivos/DeleteOrDisableFormatoArchivo';
	private restoreFormatoArchivoUrl =
		environment.rest + '/FormatosArchivos/RestoreFormatoArchivo';

	private options = {
		headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
		withCredentials: true,
	};

	constructor(private http: HttpClient, private errorService: ErrorService) {}

	getFormatosArchivos(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getFormatosArchivosUrl, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`GET -> getFormatosArchivos`
					)
				)
			);
	}

	getValidadores(idFormatoArchivo: number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.getValidadoresUrl,
				{ idFormatoArchivo },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST -> getValidadores`
					)
				)
			);
	}

	addFormatoArchivo(
		formato: FormatoArchivo,
		columnasFormatoArchivo: ColumnaFormatoArchivo[],
		validadores: ValidadorCarga[]
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.addFormatoArchivoUrl,
				{ formato, columnasFormatoArchivo, validadores },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST -> addFormatoArchivo`
					)
				)
			);
	}

	updateFormatoArchivo(
		formato: FormatoArchivo,
		columnasFormatoArchivo: ColumnaFormatoArchivo[],
		validadores: ValidadorCarga[]
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.updateFormatoArchivoUrl,
				{ formato, columnasFormatoArchivo, validadores },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST -> updateFormatoArchivo`
					)
				)
			);
	}

	deleteFormatoArchivo(id: number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.deleteFormatosArchivosUrl,
				{ id: id },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST -> deleteFormatoArchivo`
					)
				)
			);
	}

	getColumnasFormatoArchivo(idFormatoArchivo: number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.getColumnasFormatoArchivoUrl,
				{ idFormatoArchivo: idFormatoArchivo },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST -> getColumnasFormatoArchivo`
					)
				)
			);
	}

	getColumnasSistema(
		idTipoCargaDatos: TipoCargaDatosEnum = TipoCargaDatosEnum.CargaVolumen
	): Observable<Respuesta> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append(
			'idTipoCargaDatos',
			idTipoCargaDatos.toString()
		);
		return this.http
			.get<Respuesta>(this.getColumnasSistemaUrl, {
				...this.options,
				params: queryParams,
			})
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`GET -> getColumnasSistema`
					)
				)
			);
	}

	upload(formData): Observable<Respuesta> {
		var options = {
			withCredentials: true,
			// headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }), //con esto no anda. nose porq (krone)
		};
		return this.http
			.post<Respuesta>(this.uploadFileUrl, formData, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> upload`)
				)
			);
	}

	//////////////////////////////////////////////

	deleteOrDisableFormatoArchivo(id: number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.deleteOrDisableFormatoArchivoUrl,
				{ id: id },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST -> deleteOrDisableFormatoArchivo`
					)
				)
			);
	}

	restoreFormatoArchivo(id: number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.restoreFormatoArchivoUrl,
				{ id: id },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST -> restoreFormatoArchivo`
					)
				)
			);
	}

	getTiposDatos(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getTiposDatosUrl, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`GET -> getTiposDatos`
					)
				)
			);
	}

	getTiposDatosByIdCliente(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getTiposDatosByIdClienteUrl, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`GET -> getTiposDatos`
					)
				)
			);
	}

	////////////////////////////////////////////////

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<Respuesta> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			console.log(`${operation} failed: ${error.message}`);

			// Let the app keep running by returning an empty result.
			return of(new Respuesta());
		};
	}
}
